import React, { useState } from 'react';

import { routes } from '../../../../constants';
import { AddMenuButton } from '../MuiCardBase/MuiCardBase';
import { 
  CourseMuiCardProps, PublisherMetadata, ThemeMetadata 
} from './CourseMuiCard';
import { useTranslation } from 'react-i18next';
import CourseRegistrationStatus from './CourseRegistrationStatus';
import { joinAuthorNames, courseTypeToPresentationNameMap } from './utils';
import CardContainer from '../MuiCardBase/MuiCardBaseShort/MuiCardBaseShortContainer';
import CardCover from '../MuiCardBase/MuiCardBaseCover';
import CardMainContent from '../MuiCardBase/MuiCardBaseShort/MuiCardBaseShortMainContent';
import CardContentWrapper from '../MuiCardBase/MuiCardBaseShort/MuiCardBaseShortContentWrapper';
import CardMetadata from '../MuiCardBase/MuiCardBaseShort/MuiCardBaseShortMetadata';
import ShowLessButton from '../MuiCardBase/MuiCardBaseShort/MuiCardBaseShortShowLessButton';
import CardDescription from '../MuiCardBase/MuiCardBaseShort/MuiCardBaseShortDescription';
import CardDetails from '../MuiCardBase/MuiCardBaseShort/MuiCardBaseShortDetails';
import CardHeaderWithTitle from '../MuiCardBase/MuiCardBaseShort/MuiCardBaseShortHeaderWithTitle';

export const CourseMuiShortCard: React.FC<CourseMuiCardProps> = ({
  id, contentType, publisher, index, cover, title, description, isPinned, isNew, itemData, course,
}) => {
  const { t } = useTranslation();
  const [isTruncated, setIsTruncated] = useState(true);
  const toggleTruncated = () => setIsTruncated(!isTruncated);

  const itemLink: string = `/${routes.courseCatalog.root}/${id}`;
  const authorNames = joinAuthorNames(course.authors);

  return (
    <CardContainer contentType={contentType} isNew={isNew} isTruncated={isTruncated}>
      <AddMenuButton
        isPinned={isPinned}
        type={contentType}
        id={id}
        itemData={itemData}
        index={index}
      />
      <CardMainContent>
        <CardCover cover={cover} itemLink={itemLink} withPlayIcon isTruncated={isTruncated}>
          <CourseRegistrationStatus registrationStatus={course.registrationStatus} />
        </CardCover>
        <CardContentWrapper isTruncated={isTruncated}>
          <CardHeaderWithTitle
            header={courseTypeToPresentationNameMap[course.type]}
            title={title}
            caption={authorNames}
            itemLink={itemLink}
            isTruncated={isTruncated}
          />
          <CardMetadata isTruncated={isTruncated} toggleTruncated={toggleTruncated}>
            <span>{course.duration} {t('Minutes')}</span>
          </CardMetadata>
        </CardContentWrapper>
      </CardMainContent>
      {!isTruncated && 
        <>
          <ShowLessButton toggleTruncated={toggleTruncated} />
          <CardDescription description={description} />
          <CardDetails>
            <ThemeMetadata theme={course.theme} />
            <PublisherMetadata publisher={publisher} />
          </CardDetails>
        </>
      }
    </CardContainer>
  );
};

export default CourseMuiShortCard;
